// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"b046b7d9","85":"a91fac76","97":"96fa7087","210":"96fa7087","286":"96fa7087","431":"96fa7087","576":"96fa7087","833":"96fa7087"}[chunkId] + ".chunk.css";
};